import { auth } from '../../api/Endpoints';
import { QUERY_KEYS } from '../../api/config';
import type { LoginFormValues, User } from './Login.model';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useLoginQuery = (
  onSuccess?: (data: User, formData?: LoginFormValues) => void,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: (data, formData) => {
      queryClient.setQueryData([QUERY_KEYS.USER_DETAILS], data);

      if (onSuccess) {
        onSuccess(data, formData);
      }
    },
    mutationFn: (formData: LoginFormValues) => {
      return auth.login(formData);
    },
  });
};

export const useLogoutQuery = (options = {}) => {
  return useQuery({
    ...options,
    queryKey: [QUERY_KEYS.LOG_OUT],
    queryFn: async () => {
      const response = await auth.logout();
      return response.data;
    },
    enabled: false,
  });
};
